import { Slide } from "react-reveal";
import StepCard from "../reusables/StepCard";
import launch from "../../assets/images/solutions-icon/launch.svg";
import work from "../../assets/images/solutions-icon/work.svg";
import contract from "../../assets/images/solutions-icon/agree.svg";
import chat from "../../assets/images/solutions-icon/chat.svg";

const HowWeWork = () => {
  return (
    <section className="how-we-work section-spacing-100 cloudy-bg">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head width-600 section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">OUR PROCESS</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">How We Work</h2>
              </Slide>
              <p className="section-subtitle font-inter-regular">
                A proven process for delivering reliable, scalable and
                high-performance technology solutions. The 4-steps NTUNA way
                &trade;.
              </p>
            </div>
            <div className="section-body">
              <ul className="how-steps-container">
                <StepCard
                  icon={chat}
                  title="Reach Out & Discovery"
                  subtitle="You reach out, we engage you to understand your needs, goals, and project specifications."
                  step="Step 1"
                />
                <StepCard
                  icon={contract}
                  title="Quotation & Contract"
                  subtitle="We prepare a tailored quotation, agree on budget, scope and payment plan. Then make initial deposit."
                  step="Step 2"
                />
                <StepCard
                  icon={work}
                  title="Development & Feedback"
                  subtitle="We begin the project, working closely with you through regular updates, feedback and testing."
                  step="Step 3"
                />
                <StepCard
                  icon={launch}
                  title="Delivery & Launch"
                  subtitle="After final approvals and payment, we finalize project report, hand over assets and support project launch."
                  step="Step 4"
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWeWork;
